import React from "react";

/**
 * The component for rendering the Bootstrap modal header.
 *
 * @param {object} props Initial props
 * @returns {object} The React element
 */
function ModalHeader(props) {
  /* eslint-disable react/jsx-no-literals */
  return (
    <div className="modal-header">
      <button aria-hidden="true" className="close" data-dismiss="modal" type="button">
        &times;
      </button>
      <h4 className="modal-title">{props.title}</h4>
    </div>
  );
  /* eslint-enable react/jsx-no-literals */
}

export default ModalHeader;
